import { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'motion/react';

const FUN_FACTS = [
  { emoji: '📊', text: 'Regularizar tus declaraciones atrasadas te pone en buena posición ante el SAT y evita requerimientos futuros' },
  { emoji: '⏰', text: 'En promedio pasan 363 días entre que vence una declaración y se paga. Ponerte al corriente hoy te ahorra recargos' },
  { emoji: '📱', text: 'El 57% de los contribuyentes digitales en México tienen nómina y además generan ingresos independientes' },
  { emoji: '📅', text: 'Presentar tu declaración anual puede darte un saldo a favor. Muchos usuarios recuperan dinero del SAT' },
  { emoji: '🇲🇽', text: 'Más de 30,000 contribuyentes en México ya usan heru para cumplir con el SAT sin complicaciones' },
  { emoji: '💡', text: 'Los freelancers en RESICO son los contribuyentes con mejor cumplimiento fiscal de todo México' },
  { emoji: '🎯', text: 'Con heru no solo presentas tus declaraciones, te avisamos si hay algo que necesites atender' },
  { emoji: '🙌', text: '7 de cada 10 usuarios de heru nos recomiendan con amigos y familiares' },
];

export const SyncFunFacts = () => {
  const [idx, setIdx] = useState(() => Math.floor(Math.random() * FUN_FACTS.length));

  useEffect(() => {
    const timer = setInterval(() => setIdx((p) => (p + 1) % FUN_FACTS.length), 4000);
    return () => clearInterval(timer);
  }, []);

  const fact = FUN_FACTS[idx];

  return (
    <AnimatePresence mode='wait'>
      <motion.div
        key={idx}
        initial={{ opacity: 0, y: 12 }}
        animate={{ opacity: 1, y: 0 }}
        exit={{ opacity: 0, y: -12 }}
        transition={{ duration: 0.4, ease: 'easeInOut' }}
        className='flex flex-col items-center text-center'
      >
        <p className='text-h-text-light text-[10px] font-semibold tracking-widest uppercase'>¿Sabías que?</p>
        <p className='mt-3 text-4xl'>{fact.emoji}</p>
        <p className='text-h-text-heading mt-4 text-base md:text-lg font-bold leading-snug'>{fact.text}</p>
      </motion.div>
    </AnimatePresence>
  );
};
